export default {
  getLocations(state) {
    return state.locations;
  },
  getLocationsFix(state) {
    return state.locationsFix;
  },
  getLocationsROI(state) {
    return state.locationsROI;
  },
  getLocationVisible(state) {
    return state.isVisible;
  },
  getSelectedLocation(state) {
    return state.selectedLocation;
  },
  getLocationId(state) {
    return state.locationId;
  },
  getSelectLocationModal(state) {
    return state.selectLocationModal;
  },
  getLocationsGroups(state) {
    return state.locationsGroup;
  },
  getLocationsGroupsWithDate(state) {
    return state.locationsGroupFromDate;
  },
  getCreateDialogVisible(state) {
    return state.createDialogVisible;
  },
  getLocationByGroup(state){
    return state.locationByGroupItem;
  }
};
